import { Component, OnInit } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {Router} from "@angular/router";
import {TranslationService} from "../../../services/translation.service";



@Component({
    selector: 'app-search-string',
    templateUrl: './search-string.component.html',
    styleUrls: ['./search-string.component.css']
})
export class SearchStringComponent  {
    typeaheadLoading: boolean;
    typeaheadNoResults: boolean;
    dataSource: Observable<any>;
    selectedValue:any;
    typeAheadUrl:string = '/search';


    constructor(private http: HttpClient, private router: Router, private translationService: TranslationService) {
        this.dataSource = Observable.create((observer: any) => {
            // Runs on every search
            observer.next(this.selectedValue);
        })
        .pipe(
            mergeMap((token: string) =>  {
                console.log('token', token);
                return this.http.get<string[]>(`${this.typeAheadUrl}?q=${token}`)
            })
        );
    }

    onSelect(event) {
        window.location.href = 'view/' + event.item.id;
    }

}
